@if (label) {
	<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
		{{ label }}
	</ic-label>
}

<div class="border" [class.disabled]="disabled" [class.icon-right]="iconRight" [formGroup]="innerForm">
	@if (icon) {
		<span class="icon">
			@if (!innerForm.get("value").value) {
				<i aria-hidden="true" [class]="icon"> </i>
			} @else {
				<i class="clear fa fa-times-circle" data-test="clear-trigger" (click)="clearForm()"> </i>
			}
		</span>
	}

	<input
		data-test="search-input"
		formControlName="input"
		type="text"
		[attr.id]="searchInputId"
		[attr.maxlength]="maxlength"
		[class.show-input]="!value"
		[placeholder]="placeholder"
		(focus)="onFocus()"
	/>

	@if (isTableCell) {
		<i class="fa fa-search search-icon"></i>
	}

	@if (value) {
		<p class="value-template">
			@if (valueTemplate) {
				<ng-template [ngTemplateOutlet]="valueTemplate" [ngTemplateOutletContext]="{ $implicit: value }" />
			} @else {
				{{ value }}
			}
		</p>
	}
</div>
<ng-content select=".errors" />

@if (showList && !disabled) {
	<div class="autocomplete-options" [class.icon-right]="iconRight">
		@if (!loading) {
			<ul>
				@if (groups && groups.length > 0) {
					@for (group of groups; track group) {
						<li class="autocomplete-options-title">
							<ng-template [ngTemplateOutlet]="titleTemplate" [ngTemplateOutletContext]="{ $implicit: group.title }" />
						</li>
						@if (group.items && group.items.length > 0) {
							@for (item of group.items; track item) {
								<li (click)="selectOption(item)">
									<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
								</li>
							}
						} @else {
							<li class="is-non-hover empty"><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
						}
					}
				} @else {
					<li class="is-non-hover empty"><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
				}
			</ul>
		} @else {
			<div class="loading"><ng-template [ngTemplateOutlet]="loadingTemplate" /></div>
		}
	</div>
}
